import { translate } from "../../../shared/l10n/translate";
import {
	CHRONOLOGICAL,
	BY_PRICE_AND_CHRONOLOGICAL,
	BY_SCORE_AND_CHRONOLOGICAL,
} from "../hotel-list/Sorting";
import { SortingSelector } from "./SortingSelector";

customElements.define(
	"esc-favorites-sorting-selector-mobile",
	class extends SortingSelector {
		constructor() {
			super([
				{
					value: CHRONOLOGICAL,
					label: translate("hotel_list_sort_by_chronology_short"),
				},
				{
					value: BY_PRICE_AND_CHRONOLOGICAL,
					label: translate("hotel_list_sort_by_price_short"),
				},
				{
					value: BY_SCORE_AND_CHRONOLOGICAL,
					label: translate("hotel_list_sort_by_score_short"),
				},
			]);
		}

		get template() {
			return this.mobileTemplate;
		}
	},
);
